export default {
    convertToYesNo(booleanValue: boolean): string {
        if (booleanValue) {
            return 'Yes';
        }
        else {
            return 'No';
        }
    }
}
